import React from 'react';
import { useTranslation } from 'react-i18next';
import AccurityIconButton from '../../buttons/components/AccurityIconButton';
export var ListReferenceFilter = function (_a) {
    var onClick = _a.onClick;
    var t = useTranslation().t;
    return (React.createElement(AccurityIconButton, { iconName: "mui:FilterListOff", title: t('list.referenceFilterTooltip'), onClick: function (e) { return onClick(e); } }));
};
export default ListReferenceFilter;
//# sourceMappingURL=ListReferenceFilter.js.map